// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@material-ui/core";
import * as User_Context$DvmAdminFrontendFr from "../../context/user/User_Context.bs.js";
import * as Context_Router$DvmAdminFrontendFr from "../../context/router/Context_Router.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../common/types/App_Types_Result.bs.js";
import * as App_Filter_Button$DvmAdminFrontendFr from "../../common/components/button/App_Filter_Button.bs.js";
import * as App_Styles_Common$DvmAdminFrontendFr from "../../common/styles/App_Styles_Common.bs.js";
import * as Pool_Expenses_Api$DvmAdminFrontendFr from "./Pool_Expenses_Api.bs.js";
import * as Pool_Expenses_Form$DvmAdminFrontendFr from "./Pool_Expenses_Form.bs.js";
import * as Pool_Expenses_Table$DvmAdminFrontendFr from "./Pool_Expenses_Table.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";
import * as App_AutocompleteFormInput$DvmAdminFrontendFr from "../../common/components/input/App_AutocompleteFormInput.bs.js";

function Pool_Expenses_Filter(Props) {
  var fetchData = Props.fetchData;
  var fetchRequest = Props.fetchRequest;
  var tableType = Props.tableType;
  var match = Curry._1(Context_Router$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var dispatch = match[1];
  var match$1 = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$2 = match$1[0];
  var userManager = match$2.userManager;
  var selectedRole = match$2.selectedRole;
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setAvailableYears = match$3[1];
  var match$4 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setRmpcs = match$4[1];
  var match$5 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setMrs = match$5[1];
  var form = Pool_Expenses_Form$DvmAdminFrontendFr.TableFilterForm.useForm(Belt_Option.getWithDefault(match[0].poolExpensesFilter, Pool_Expenses_Form$DvmAdminFrontendFr.initialState), (function (param, submissionCallbacks) {
          Curry._2(fetchData, submissionCallbacks, {
                page: 0,
                rowsPerPage: fetchRequest.rowsPerPage,
                headers: Pool_Expenses_Table$DvmAdminFrontendFr.headersConfiguration(tableType, selectedRole),
                filterQueryParams: Belt_Array.joinWith(Belt_List.toArray(Belt_List.keepMap({
                              hd: param.year,
                              tl: {
                                hd: param.periodID,
                                tl: {
                                  hd: tableType ? param.mr : param.rmpc,
                                  tl: /* [] */0
                                }
                              }
                            }, (function (queryParam) {
                                return queryParam;
                              }))), ";", (function (queryParam) {
                        return queryParam;
                      })),
                additionalQueryParams: fetchRequest.additionalQueryParams
              });
        }));
  React.useEffect((function () {
          Pool_Expenses_Api$DvmAdminFrontendFr.fetchIPNAndName(userManager, setRmpcs, selectedRole, /* RMPC */0);
          Pool_Expenses_Api$DvmAdminFrontendFr.fetchIPNAndName(userManager, setMrs, selectedRole, /* MR */1);
        }), []);
  React.useEffect((function () {
          Curry._1(form.submit, undefined);
          Pool_Expenses_Api$DvmAdminFrontendFr.fetchAvailableYears(userManager, setAvailableYears, selectedRole, tableType);
        }), [tableType]);
  return React.createElement("form", {
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(dispatch, {
                        TAG: /* StorePoolExpensesFilter */32,
                        _0: form.input
                      });
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(Core.Grid, {
                  children: null,
                  className: App_Styles_Common$DvmAdminFrontendFr.Inputs.searchFiltersBox,
                  container: true
                }, React.createElement(Core.Grid, {
                      children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, {
                            label: Messages_Common$DvmAdminFrontendFr.year,
                            value: {
                              TAG: /* Single */0,
                              _0: {
                                value: form.input.year,
                                onChange: Curry._1(form.updateYear, (function (input, year) {
                                        return {
                                                year: year,
                                                periodID: input.periodID,
                                                rmpc: input.rmpc,
                                                mr: input.mr
                                              };
                                      }))
                              }
                            },
                            options: {
                              TAG: /* Unlabeled */0,
                              _0: App_Types_Result$DvmAdminFrontendFr.getWithDefault(match$3[0], /* [] */0)
                            },
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.standardInput
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, {
                            label: Messages_Common$DvmAdminFrontendFr.period,
                            value: {
                              TAG: /* Multiple */1,
                              _0: {
                                value: form.input.periodID,
                                onChange: Curry._1(form.updatePeriodID, (function (input, periodID) {
                                        return {
                                                year: input.year,
                                                periodID: periodID,
                                                rmpc: input.rmpc,
                                                mr: input.mr
                                              };
                                      }))
                              }
                            },
                            options: {
                              TAG: /* Labeled */1,
                              _0: {
                                hd: {
                                  label: {
                                    TAG: /* Message */0,
                                    _0: Messages_Pool_Expenses$DvmAdminFrontendFr.q3Period
                                  },
                                  value: "JAS"
                                },
                                tl: {
                                  hd: {
                                    label: {
                                      TAG: /* Message */0,
                                      _0: Messages_Pool_Expenses$DvmAdminFrontendFr.q4Period
                                    },
                                    value: "OND"
                                  },
                                  tl: {
                                    hd: {
                                      label: {
                                        TAG: /* Message */0,
                                        _0: Messages_Pool_Expenses$DvmAdminFrontendFr.q1Period
                                      },
                                      value: "JFM"
                                    },
                                    tl: {
                                      hd: {
                                        label: {
                                          TAG: /* Message */0,
                                          _0: Messages_Pool_Expenses$DvmAdminFrontendFr.q2Period
                                        },
                                        value: "AMJ"
                                      },
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            },
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.chipInputExtraLongPlus,
                            limitTags: 2,
                            smallChips: true
                          }),
                      item: true
                    }), tableType ? React.createElement(Core.Grid, {
                        children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, {
                              label: Messages_Pool_Expenses$DvmAdminFrontendFr.mrIpnLabel,
                              value: {
                                TAG: /* Multiple */1,
                                _0: {
                                  value: form.input.mr,
                                  onChange: Curry._1(form.updateMr, (function (input, mr) {
                                          return {
                                                  year: input.year,
                                                  periodID: input.periodID,
                                                  rmpc: input.rmpc,
                                                  mr: mr
                                                };
                                        }))
                                }
                              },
                              options: {
                                TAG: /* Labeled */1,
                                _0: Belt_List.map(App_Types_Result$DvmAdminFrontendFr.getWithDefault(match$5[0], /* [] */0), (function (val) {
                                        return {
                                                label: {
                                                  TAG: /* String */3,
                                                  _0: val.paramOne + Belt_Option.mapWithDefault(val.paramTwo, "", (function (x) {
                                                          if (x.length > 0) {
                                                            return " - " + x + "";
                                                          } else {
                                                            return "";
                                                          }
                                                        }))
                                                },
                                                value: val.paramOne
                                              };
                                      }))
                              },
                              className: App_Styles_Common$DvmAdminFrontendFr.Inputs.chipInputLong,
                              smallChips: true
                            }),
                        item: true
                      }) : React.createElement(Core.Grid, {
                        children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, {
                              label: Messages_Pool_Expenses$DvmAdminFrontendFr.rmpcIpnLabel,
                              value: {
                                TAG: /* Multiple */1,
                                _0: {
                                  value: form.input.rmpc,
                                  onChange: Curry._1(form.updateRmpc, (function (input, rmpc) {
                                          return {
                                                  year: input.year,
                                                  periodID: input.periodID,
                                                  rmpc: rmpc,
                                                  mr: input.mr
                                                };
                                        }))
                                }
                              },
                              options: {
                                TAG: /* Labeled */1,
                                _0: Belt_List.map(App_Types_Result$DvmAdminFrontendFr.getWithDefault(match$4[0], /* [] */0), (function (val) {
                                        return {
                                                label: {
                                                  TAG: /* String */3,
                                                  _0: val.paramOne + Belt_Option.mapWithDefault(val.paramTwo, "", (function (x) {
                                                          if (x.length > 0) {
                                                            return " - " + x + "";
                                                          } else {
                                                            return "";
                                                          }
                                                        }))
                                                },
                                                value: val.paramOne
                                              };
                                      }))
                              },
                              className: App_Styles_Common$DvmAdminFrontendFr.Inputs.chipInputLong,
                              smallChips: true
                            }),
                        item: true
                      }), React.createElement(Core.Grid, {
                      children: React.createElement(App_Filter_Button$DvmAdminFrontendFr.make, {
                            label: "OK",
                            type_: "submit"
                          }),
                      item: true
                    })));
}

var Style;

var Form;

var make = Pool_Expenses_Filter;

export {
  Style ,
  Form ,
  make ,
}
/* react Not a pure module */
